import React from 'react';
import './ContactUsPage.scss';

const ContactUsPage = (props) => {

  return (
    <div className="contactuspage" style={{color: "white"}}>
        test
    </div>
  );
}

export default ContactUsPage;